import { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';

import List from './List';
import Save from './Save';

const SubsidiaryTab: FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path} component={List} />
      <Route path={`${path}/novo`} component={Save} />
      <Route path={`${path}/:subsidiaryId`} component={Save} />
    </Switch>
  );
};

export default SubsidiaryTab;
